/*
export function someMutation (state) {
}
*/
// src/store/showcase/mutations.js
export const updateDrawerState = (state, opened) => {
  state.drawerState = opened;
};
export const updateUserName = (state, opened) => {
  state.userName = opened;
};
